/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Hotpush.css';

class Hotpush extends React.Component {


  constructor(){
    super();
    this.state={};
  };

  render() {
    return(
      <div className={s.root}>
        <div className={s.model}>

        <div className={s.hotPush}>
              <div className={s.pushBrand}>
                  <p className={s.pushP}>热门品牌：
                      <a href="#">百度</a>
                      <a href="#">阿里巴巴</a>
                  </p>

              </div>
              <div className={s.pushWords}>
                  <p className={s.pushP}>热门关键词:
                      <a href="#">电商</a>
                      <a href="#">互联网</a>
                  </p>

              </div>
              <div className={s.report}>
                  <p className={s.pushP}>相关报告:
                      <a href="#">电商</a>
                      <a href="#">互联网</a>
                  </p>

              </div>
          </div>
        </div>
          
      </div>
        
    )


  }
}

export default withStyles(s)(Hotpush);



// WEBPACK FOOTER //
// src/components/Hotpush/Hotpush.js